/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, date: NonNullable<unknown> }} Partner_Manage_Storage_Pending_ChangeInputs */



/**
* | output |
* | --- |
* | "Storage changing to {label} on {date}." |
*
* @param {Partner_Manage_Storage_Pending_ChangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_storage_pending_change = /** @type {((inputs: Partner_Manage_Storage_Pending_ChangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Storage_Pending_ChangeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Speicher wechselt am ${i?.date} zu ${i?.label}.`)
	return /** @type {LocalizedString} */ (`Storage changing to ${i?.label} on ${i?.date}.`)
});